import React from 'react'
import { Icon, IconName } from '@/ui/icon2'
import Dialog from '@/ui/dialogs/Dialog'
import CTA from '@/ui/CTA'
import styles from './index.module.css'

interface ShortcutButtonProps {
  icon?: IconName
  text?: string
}

export const ShortcutButton = ({ icon, text }: ShortcutButtonProps) => {
  return (
    <div className={styles.shortcutButton}>
      {icon ? (
        <Icon name={icon} />
      ) : (
        <span className={styles.shortcutButtonText}>{text}</span>
      )}
    </div>
  )
}

interface ShortcutInfoProps {
  title: string
  description: string
  children: React.ReactNode
}

export const ShortcutInfo = ({
  title,
  description,
  children,
}: ShortcutInfoProps) => {
  return (
    <div className={styles.shortcutInfo}>
      <div className={styles.shortcutInfoButtons}>{children}</div>
      <div className={styles.shortcutInfoText}>
        <p className={styles.shortcutInfoTitle}>{title}</p>
        <p className={styles.shortcutInfoDescription}>{description}</p>
      </div>
    </div>
  )
}

const isMac = () => {
  return (
    navigator.platform.toUpperCase().indexOf('MAC') >= 0 ||
    navigator.userAgent.toUpperCase().indexOf('MAC') >= 0
  )
}

const getModifierKey = () => {
  return isMac() ? { icon: 'cmd' as IconName } : { text: 'Ctrl' }
}

interface ShortcutsDialogProps {
  dialogRef: React.RefObject<any>
  onClose: () => void
}

export const ShortcutsDialog = ({
  dialogRef,
  onClose,
}: ShortcutsDialogProps) => {
  return (
    <Dialog
      ref={dialogRef}
      icon="cmd"
      title="Atajos de teclado"
      text="A continuación podrás ver una lista completa de todos los atajos que puedes utilizar para manjear AiKit desde tu teclato."
      onClose={onClose}
      actions={
        <CTA variant="default" size="medium" onClick={onClose}>
          Cerrar
        </CTA>
      }
    >
      <div>
        <ShortcutInfo
          title="Nuevo chat"
          description="Inicia una nueva conversación desde cualquier lugar."
        >
          <ShortcutButton {...getModifierKey()} />
          <ShortcutButton text="I" />
        </ShortcutInfo>
        <ShortcutInfo
          title="Cambiar modo experto"
          description="Activa o desactiva el modo experto del chat."
        >
          <ShortcutButton {...getModifierKey()} />
          <ShortcutButton text="M" />
        </ShortcutInfo>
        <ShortcutInfo
          title="Abrir el historial"
          description="Accede al historial desde cualquier lugar."
        >
          <ShortcutButton {...getModifierKey()} />
          <ShortcutButton text="H" />
        </ShortcutInfo>
        <ShortcutInfo
          title="Volver a empezar"
          description="Vuelve al inicio de una herramienta para comenzar desde cero."
        >
          <ShortcutButton {...getModifierKey()} />
          <ShortcutButton icon="arrow-left" />
        </ShortcutInfo>
        <ShortcutInfo
          title="Editar resultado"
          description="Abre el modo edición dentro de una herramienta."
        >
          <ShortcutButton {...getModifierKey()} />
          <ShortcutButton text="E" />
        </ShortcutInfo>
      </div>
    </Dialog>
  )
}
